import { useContext } from 'react';
import { ZIndexContext } from 'contexts/ZIndexContext';

export function useZIndex() {
  return useContext(ZIndexContext);
}
